import Reveal from '@/components/base/Reveal';
import ContactForm from './ContactForm';
import { contactImage, snsLinks } from '@/mocks/site';

const availableSns = snsLinks.filter((sns) => sns.available);
const qrSns = snsLinks.filter((sns) => !sns.available && sns.qr);

export default function Contact() {
  return (
    <section id="contact" className="border-t border-background-200/60 bg-background-50 px-5 py-16 pr-14 md:px-10 md:py-24 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <Reveal variant="mask" duration={1200} className="overflow-hidden rounded-lg">
          <div className="relative h-[280px] w-full overflow-hidden sm:h-[340px] md:h-[400px]">
            <img src={contactImage} alt="夜のトライアルフェスタ会場と灯り" className="animate-ken-burns h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/25" />
            <div className="absolute inset-0 flex flex-col justify-end p-5 pr-12 md:p-9 md:pr-16">
              <p className="text-[10px] en-label text-accent-300">CONTACT</p>
              <h2 className="mt-2.5 font-heading text-[24px] font-black leading-[1.35] text-background-50 md:text-[36px]">
                まずは、話を聞かせてください。
              </h2>
              <p className="mt-3 max-w-xl text-[12px] leading-[1.9] text-background-50/80 md:text-[13px]">
                「こんな出店はできる？」「協賛の相談がしたい」「出演してみたい」。どんな小さなご相談でも構いません。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                <a
                  href="#vendor"
                  className="inline-flex cursor-pointer items-center gap-2 rounded-md bg-secondary-500 px-4 py-2.5 text-[11.5px] font-bold text-white transition-colors duration-300 hover:bg-secondary-600"
                >
                  <i className="ri-store-2-line" aria-hidden="true" />
                  出店申込へ
                </a>
                <a
                  href="#sponsor"
                  className="inline-flex cursor-pointer items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-[11.5px] font-bold text-background-50 transition-colors duration-300 hover:bg-primary-600"
                >
                  <i className="ri-mail-send-line" aria-hidden="true" />
                  協賛の相談へ
                </a>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-8 md:mt-14 md:grid-cols-12 md:gap-10">
          <div className="md:col-span-5">
            <Reveal variant="up">
              <h3 className="font-heading text-[18px] font-black text-foreground-950 md:text-[20px]">SNS・お問い合わせ先</h3>
              <p className="mt-2.5 text-[12px] leading-[1.9] text-foreground-600">
                最新の開催情報はSNSで発信しています。ご連絡は公式LINE・SNSのDMを基本とし、電話・メールでも対応しています。
              </p>
            </Reveal>

            <Reveal variant="up" delay={120} className="mt-5">
              <div className="divide-y divide-background-300 border-y border-background-300">
                {availableSns.map((sns) => (
                  <a
                    key={sns.name}
                    href={sns.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex cursor-pointer items-center gap-3 py-3.5"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-800 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                      <i className={`${sns.icon} text-[15px]`} aria-hidden="true" />
                    </span>
                    <span className="flex-1">
                      <span className="block text-[12.5px] font-bold text-foreground-900">{sns.name}</span>
                      <span className="block text-[11px] text-foreground-500">{sns.handle}</span>
                    </span>
                    <i className="ri-arrow-right-up-line text-foreground-400 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
                  </a>
                ))}
              </div>
            </Reveal>

            <Reveal variant="up" delay={180} className="mt-6">
              <div className={`mt-6 ${qrSns.length > 1 ? 'grid grid-cols-2 gap-3' : 'grid gap-3'}`}>
                {qrSns.map((sns) => (
                  <div key={sns.name} className="rounded-md border border-background-300 bg-background-50 p-3.5 text-center">
                    <div className="mx-auto h-[84px] w-[84px] overflow-hidden rounded-sm bg-background-100">
                      <img src={sns.qr} alt={`${sns.name}のQRコード`} className="h-full w-full object-cover" />
                    </div>
                    <p className="mt-2.5 flex items-center justify-center gap-1.5 text-[11.5px] font-bold text-foreground-900">
                      <i className={`${sns.icon} text-[13px]`} aria-hidden="true" />
                      {sns.name}
                    </p>
                    <p className="mt-1 text-[10px] leading-relaxed text-foreground-400">QRコードからアクセス</p>
                  </div>
                ))}
              </div>
              <p className="mt-3 text-[10.5px] leading-relaxed text-foreground-400">
                ※ LINEのリンクURLは準備中のため、現在はQRコードをご利用ください。取得後にリンクを設定します。
              </p>
            </Reveal>
          </div>

          <div className="md:col-span-7">
            <Reveal variant="up" delay={100}>
              <ContactForm />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}